import { debounce } from "throttle-debounce";

function setActive(index, delay = 500) {
    const activeClass = "active";
    const rulerSelector = ".intro__cats__col--ruler";

    const totalW = $(".intro__cats").width();
    const smallW = $(rulerSelector).outerWidth();

    const $cols = $(".intro__cats__col").not(rulerSelector);

    $cols
        .not(":eq(" + index + ")")
        .removeClass(activeClass)
        .stop()
        .animate(
            {
                width: smallW,
            },
            delay
        );

    $cols
        .eq(index)
        .addClass(activeClass)
        .stop()
        .animate(
            {
                width: totalW - 3 * smallW,
            },
            delay
        );
}

$(function () {
    $(document).on("mouseenter", ".intro__cats__col", function (e) {
        const index = $(e.currentTarget).index();
        setActive(index);
    });

    $(document).on("mouseleave", ".intro__cats", function () {
        setActive(0);
    });

    $(window).on(
        "resize",
        debounce(100, () => {
            setActive(0, 0);
        })
    );

    setActive(0);
});
